import investmentActionLang from './langs/investmentActionLang';
import investmentDisclaimerLang from './langs/investmentDisclaimerLang';
import investmentFilterLang from './features/fund-type/langs/investmentFilterLang';
import investmentKpiLang from './langs/investmentKpiLang';
import langUserNavigation from '../user/langs/langUserNavigation';
import investmentPageLang from './langs/investmentPageLang';
import investmentTableLang from './features/fund-type/langs/investmentTableLang';
import investmentTypeArticleLang from './features/fund-type/langs/investmentTypeArticleLang';
import investmentTypeDomainLang from './features/fund-type/langs/investmentTypeDomainLang';
import investmentTypeLang from './features/fund-type/langs/investmentTypeLang';
import investmentTypeOngletLang from './features/fund-type/langs/investmentTypeOngletLang';
import langInvestWordLang from './langs/langInvestWordLang';
import investmentTypeHistoryLang from './features/fund-type/langs/investmentTypeHistoryLang';
import investmentFundLang from './langs/investmentFundLang';
import investorContactLang from './features/contact-drawer/langs/investorContactLang';
import investmentFundTypeHistoryFlowLang from './features/fund-type/langs/investmentFundTypeHistoryFlowLang';
import langInvestFundPerformancesPrivateCreditLang from './langs/langInvestFundPerformancesPrivateCreditLang';
import investmentFundOperationsLang from './langs/investmentFundOperationsLang';
import investmentFundInformationsLang from './langs/investmentFundInformationsLang';
import investmentFundDocumentsLang from './langs/investmentFundDocumentsLang';
import investmentFundQuestionLang from './langs/investmentFundQuestionLang';
import langUserProfile from '../user/langs/langUserProfile';
import investmentFundStatusLang from './features/fund-type/langs/investmentFundStatusLang';
import langUserFirstLogin from '../user/langs/langUserFirstLogin';
import investmentFundAssetsLang from './langs/investmentFundAssetsLang';
import langInvestFundPerformancesVentureCapitalLang from './langs/langInvestFundPerformancesVentureCapitalLang';
import investExpertiseSynthesisVentureCapitalLang from './features/fund-type/langs/investExpertiseSynthesisVentureCapitalLang';
import investExpertiseAssetsTable from './features/fund-type/langs/investExpertiseAssetsTable';
import investExpertiseAssetsSector from './features/fund-type/langs/investExpertiseAssetsSector';
import langInvestFundAssetsTable from './langs/langInvestFundAssetsTable';
import investTagAssetClassLang from './features/fund-type/langs/investTagAssetClassLang';
import investExpertiseListedAssetsLang from './langs/investExpertiseListedAssetsLang';
import investTagThematiqueLang from './features/fund-type/langs/investTagThematiqueLang';
import investTagLabelLang from './features/fund-type/langs/investTagLabelLang';
import investTagClassificationAMFLang from './features/fund-type/langs/investTagClassificationAMFLang';
import investTagPlacementDurationLang from './features/fund-type/langs/investTagPlacementDurationLang';
import investTagRiskLevelLang from './features/fund-type/langs/investTagRiskLevelLang';
import langInvestDashboardMultiExpertises from './langs/langInvestDashboardMultiExpertises';
import investorContactAllLang from './features/contact-drawer/langs/investorContactAllLang';
import langInvestFundPerformancesListedAssetsLang from './langs/langInvestFundPerformancesListedAssetsLang';
import langInvestDateRangePicker from './langs/langInvestDateRangePicker';
import investExpertiseAssetsTableListedAssets from './features/fund-type/langs/investExpertiseAssetsTableListedAssets';

const InvestorLangs = [
	investmentDisclaimerLang,
	investorContactAllLang,
	investmentKpiLang,
	langUserNavigation,
	investmentTypeLang,
	investmentTypeDomainLang,
	langInvestWordLang,
	investmentPageLang,
	investmentFilterLang,
	investmentTypeArticleLang,
	investmentTypeOngletLang,
	investmentActionLang,
	investmentTableLang,
	investmentTypeHistoryLang,
	investmentFundLang,
	investorContactLang,
	investmentFundTypeHistoryFlowLang,
	langInvestFundPerformancesListedAssetsLang,
	langInvestFundPerformancesPrivateCreditLang,
	langInvestFundPerformancesVentureCapitalLang,
	investmentFundOperationsLang,
	investmentFundInformationsLang,
	investmentFundDocumentsLang,
	investmentFundQuestionLang,
	investExpertiseAssetsSector,
	langUserProfile,
	investmentFundStatusLang,
	langUserFirstLogin,
	investmentFundAssetsLang,
	investExpertiseSynthesisVentureCapitalLang,
	investExpertiseAssetsTable,
	investExpertiseAssetsTableListedAssets,
	langInvestFundAssetsTable,
	investTagAssetClassLang,
	investExpertiseListedAssetsLang,
	investTagThematiqueLang,
	investTagLabelLang,
	investTagClassificationAMFLang,
	investTagPlacementDurationLang,
	investTagRiskLevelLang,
	langInvestDashboardMultiExpertises,
	langInvestDateRangePicker,
];

export default InvestorLangs;
